<template>
  <app-base-main
      :hasMagin="false"
      no-padding
      parentTable
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          :fixWidth="200"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-select
            v-model="filter.status"
            :options="AdCampaignEnum.SP.statusOptionNew"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="filter.servingStatus"
            :options="options.budgetStatus"
            placeholder="预算状态"
        ></gj-select>
        <gj-select
            v-model="filter.type"
            :options="AdCampaignEnum.SP.targetingTypeOption"
            placeholder="类型"
        ></gj-select>
        <gj-select
            v-model="filter.strategy"
            :options="AdCampaignEnum.SP.bidStrategyOption"
            placeholder="竞价策略"
            width="160px"
        ></gj-select>
        <gj-select
          v-model="filter.strategyStatus"
          :options="AdStrategyStatusEnum.option"
          placeholder="分时策略"
        ></gj-select>
         <gj-select
          v-model="filter.automateRuleStatus"
          :options="automateRuleOption"
          placeholder="自动规则"
        ></gj-select>
        <gj-lazy-input
            v-model="filter.keyword"
            placeholder="广告活动名称"
            width="150px"
        ></gj-lazy-input>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/campaigns/export" :download-params="globalParams"
          >
          <template #before>
            <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
          </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          @click="add"
      >新增广告活动</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SP.status.ARCHIVE)"
          @click="adjustBudget">
        调整预算
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SP.status.ARCHIVE)"
          @click="updateEndDate"
      >修改结束日期</gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdCampaignEnum.SP.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIs('state', AdCampaignEnum.SP.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="!selectedAllIn('state', [AdCampaignEnum.SP.status.ENABLE, AdCampaignEnum.SP.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SP.status.ARCHIVE)"
          @click="movePortfolio">
        移动分组
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
        :helpName="helpName"
        log @viewLog="viewLog"
        help
        setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
        :download="$permission('adsSpCampaigns:export')" download-url="/ads/sp/campaigns/export" :download-params="globalParams">
        <template #before>
          <span v-if="lastUpdatedDate" style="color: #999; font-size: 12px; padding-right: 6px">更新时间（{{ countryName }}）：{{ lastUpdatedDate }}</span>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :show-header-overflow="true"
          :show-footer-overflow="true"
          :pagination="pagination"
          show-summary :summary-object="sumRecord"
          :selectable="notEqSelectable('state', AdCampaignEnum.SP.status.ARCHIVE)"
          :scroll-y="{mode: 'wheel', oSize:10, gt: 40 }"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdCampaignEnum.SP.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdCampaignEnum.SP.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdCampaignEnum.SP.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:campaignName="{ row }">
          <div class="campaignName-content" v-if="row.state !== AdCampaignEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')">
            <gj-edit-input
              :value="row.campaignName"
              :item="row"
              table-cell-edit
              :validator="campaignNameValidator"
              :on-confirm="updateCampaignName"
              :pop-title="'广告活动名称'">
              <app-sp-ad-route-link
                :ad-campaign-manager="{marketId, campaign: row, date: filter.date}">
                <gj-tooltip
                    :text-line="2"
                    :content="row.campaignName">
                  {{row.campaignName | defaultShow}}
                </gj-tooltip>
              </app-sp-ad-route-link>
            </gj-edit-input>
            <div class="gj-cell-display-switch">
              <app-ad-route-link :market-id="row.marketId" :type="AdTypeEnum.SP" :campaign="row">
                <gj-tooltip content="新标签页打开" >
                  <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                </gj-tooltip>
              </app-ad-route-link>
            </div>
          </div>
          <template v-else>
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </template>
        </template>

        <template v-slot:servingStatus="{ row }">
          <!--暂时隐藏-->
          <!--若状态为超出预算，用link，点击打开预算分析弹框-->
         <gj-link v-if="row.servingStatus==='CAMPAIGN_OUT_OF_BUDGET'" class="color333" @click="openOutOfBudgetModal(row)">
           {{ row.servingStatus | optionText(AdCampaignEnum.SP.servingStatusOption) | defaultShow }}
           <i class="iconfont icona-Group46 gj-cell-display-switch" style="font-size: 12px;margin-left: 4px;"></i>
         </gj-link>
        <!--否则正常显示状态-->
         <div v-else>{{row.servingStatus | optionText(AdCampaignEnum.SP.servingStatusOption) | defaultShow}}</div>
          <div v-if="isMeaningful(row.dailyBudgetLog)" style="color: red;">{{row.dailyBudgetLog}}</div>
        </template>
        <template v-slot:endDate="{ row }">
          {{ row.endDate || '无结束日期' }}
          <AdEditDateEnd
            :value="row"
            :isEdit="row.state !== AdCampaignEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :updateValue="updateDateEnd"
          ></AdEditDateEnd>
        </template>

        <template v-slot:header:suggestedBudget>
          <div class="flex align-center">
            <div style="width: 90px;text-align: right;margin-right: 10px;">
              建议预算
              <gj-help>亚马逊建议的广告活动预算，以降低广告活动预算耗尽而错过曝光量、点击量和销量的概率。</gj-help>
            </div>

            <gj-button type="text" @click="updateDailyBudgetAll">全部应用</gj-button>

          </div>

        </template>
        <template v-slot:suggestedBudget="{ row }">
          <div class="flex align-center">
            <div class="popover-out">
              <gj-popover trigger="hover" placement="bottom" :disabled="isMeaningless(row.suggestedBudget)">

                <div class="flex popover-tit">
                  <div class="size14 popover-tit1">流量损失预估</div>
                  <div class="size12 color666">您的广告在{{row.budgetStartDate | defaultShow}} - {{row.budgetEndDate | defaultShow}}期间预估损失的流量。</div>
                </div>

                <div class="size12 color333 popover-box">
                  <div class="flex align-center popover-box-header">
                    <div class="col1">
                      平均预算内活跃时间
                      <gj-help>过去一段时间您的广告活动在预算中的活跃时间占总时间的百分比</gj-help>
                    </div>
                    <div class="col2">
                      预计错过的曝光
                      <gj-help>如果预算未耗尽，预计广告活动可能获得的额外曝光量。取决于多种因素，可能包括预计错过的点击量和历史点击率 (CTR)。只是估计值，并非实际曝光量保证。部分广告活动可能没有足够的数据计算估计值</gj-help>
                    </div>
                    <div class="col3">
                      预计错过的点击
                      <gj-help>如果预算未耗尽，预计广告活动可能获得的额外点击量。取决于多种因素，可能包括未耗尽预算的类似广告活动的历史绩效。只是估计值，并非实际点击量保证。部分广告活动可能没有足够的数据计算估计值</gj-help>
                    </div>
                    <div class="col4">
                      预计错过的销售额
                      <gj-help>如果预算未耗尽，预计广告活动可能获得的额外销售额。取决于多种因素，可能包括未耗尽预算的类似广告活动的历史绩效。只是估计值，并非实际点击量保证。部分广告活动可能没有足够的数据计算估计值</gj-help>
                    </div>
                    <div class="col5">
                      建议预算
                      <gj-help>亚马逊建议的广告活动预算，以降低广告活动预算耗尽而错过曝光量、点击量和销量的概率</gj-help>
                    </div>
                  </div>
                  <div class="flex align-center popover-box-row">
                    <div class="col1 flex align-center color666">
                      <el-progress :percentage="row.percentTimeInBudget||0" :stroke-width="12" color="#1F6EEF" :show-text="false" class="progress"></el-progress>
                      {{ row.percentTimeInBudget | amount | defaultShow('','%') }}
                    </div>
                    <div class="col2">
                      <template v-if="isMeaningful(row.estimatedMissedImpressionsLower)">
                        {{row.estimatedMissedImpressionsLower}} - {{row.estimatedMissedImpressionsUpper}}
                      </template>
                      <template v-else>-</template>
                    </div>
                    <div class="col3">
                      <template v-if="isMeaningful(row.estimatedMissedClicksLower)">
                        {{row.estimatedMissedClicksLower}} - {{row.estimatedMissedClicksUpper}}
                      </template>
                      <template v-else>-</template>
                    </div>
                    <div class="col4">
                      <template v-if="isMeaningful(row.estimatedMissedSalesLower)">
                        {{row.estimatedMissedSalesLower | amount | defaultShow(row.currencySymbol)}} - {{row.estimatedMissedSalesUpper | amount | defaultShow(row.currencySymbol)}}
                      </template>
                      <template v-else>-</template>
                    </div>
                    <div class="col5">
                      {{ row.suggestedBudgetShow | amount | defaultShow(row.currencySymbol) }}
                      <gj-button v-if="isMeaningful(row.suggestedBudget)" type="text" style="margin-left: 4px;" @click="updateDailyBudget(row.suggestedBudget,row)">应用</gj-button>
                    </div>
                  </div>
                </div>

                <div slot="reference">
                  {{ row.suggestedBudgetShow | amount | defaultShow(row.currencySymbol) }}
                  <i v-if="isMeaningful(row.suggestedBudget)" class="el-icon-arrow-down"></i>
                </div>
              </gj-popover>

            </div>

            <gj-button v-if="isMeaningful(row.suggestedBudget)" type="text" @click="updateDailyBudget(row.suggestedBudget,row)">应用</gj-button>

          </div>
        </template>

        <template v-slot:dailyBudget="{ row }">
          {{ row.dailyBudget | amount | defaultShow(row.currencySymbol) }}
          <AdDailyBudgetEdit
            :value="row"
            :isEdit="row.state !== AdCampaignEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :currencySymbol="row.currencySymbol"
            :updateValue="updateDailyBudget">
          </AdDailyBudgetEdit>
        </template>
        <template v-slot:bidStrategy="{ row }">
          {{ row.biddingVO.strategy | bidStrategy }}
          <AdBidStrategyEdit
            :value="row"
            :isEdit="row.state !== AdCampaignEnum.SP.status.ARCHIVE && $permission('adsSpCampaigns:addOrUpdate')"
            :updateValue="updateBidStrategy"
          ></AdBidStrategyEdit>
        </template>
        <template v-slot:strategyStatus="{ row }">
        {{AdStrategyStatusEnum.option[row.strategyStatus].text || row.strategyStatus}}
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 0 || row.strategyStatus === 1">
            <gj-tooltip content="编辑">
              <i class="el-icon-edit color999" @click="timeAdjust(row)"></i>
            </gj-tooltip>
            <gj-tooltip content="移除">
              <i class="iconfont iconshanchu size13 color999" style="margin-left: 10px;" @click="deleteEvent(row)"></i>
            </gj-tooltip>
          </div>
          <div class="gj-cell-display-switch"  v-if="row.strategyStatus === 2">
                <gj-button type="text" @click="timeAdjust(row)" >去添加</gj-button>
          </div>
        </template>
        <template v-slot:ruleStatus="{index, row }">
           <div v-if="row.ruleStatus === 'archived'">
              <span style="marginRight: 6px;">未添加</span>
              <div class="gj-cell-display-switch" v-if="row.ruleStatus === 'archived'">
                  <gj-button type="text" @click="handleAdd(row)" >去添加</gj-button>
              </div>
           </div>
           <div v-else>
              <el-popover @show="handlePop(index)" placement="top" trigger="click" popper-class="ad-rule-pop">
                <template slot="reference">
                  <div  style="color: #1F6EEF"  @click="handleRule(row)">{{row.ruleNum | defaultShow}}</div>
                </template>
                 <autoRule 
                  v-if="index === autoRuleindex"
                  :adEntry="true"
                  :autoRuleData="autoRuleData" 
                  :row="{marketId: row.marketId, objectId: row.campaignId, objectType: 'campaign',campaignId: row.campaignId, objectName: row.campaignName, adType: 'sp', campaignName: row.campaignName}" 
                  :index="index" :ref="`autoRuleRef${index}`" 
                  @update="ruleUpdate"></autoRule>
              </el-popover>

           </div>
        </template>
        <template v-slot:op="{ row }">
          <gj-button
              v-if="row.state === AdCampaignEnum.SP.status.ARCHIVE || !$permission('adsStrategyObject:add')"
              type="text"
              @click="viewLog(row)">
            操作日志
          </gj-button>
          <gj-button-group
              v-else
              type="dropdown-op">
             <gj-button type="text" v-if="false" @click="viewAdjustLog(row)">调价日志</gj-button>
             <gj-button type="text" v-if="row.state!==2" @click="openOutOfBudgetModal(row)">预算分析</gj-button>
            <template #dropdown>
              <gj-dropdown-item @click="viewLog(row)">操作日志</gj-dropdown-item>
            </template>
          </gj-button-group>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {subDays} from 'date-fns';
  import {OpEnum} from "@/utils/options";
  import {queryMixin, responseMixin, selectionMixin, isMeaningfulMixin} from "@/minxins";
  import {addAdsAdjustStrategy, updateAdsAdjustStrategyObject, updateSpAdCampaign, SP, batchUpdateStrategyObject, deleteAdsAdjustStrategyTpl} from "@/api/ad";
  import {AdCampaignEnum, AdStrategyStatusEnum, AdTypeEnum, BudgetStatus, AdLog, AdBidStrategyTypeEnumOptions} from "@/views/modules/ad/common/enum";
  import AppAdjustBudgetModal from "../../../common/modal/adjust/adjust-budget-modal";
  import AppMovePortfolioModal from "../../common/modal/move-portfolio/move-portfolio-modal";
  import AppUpdateEndDateModal from "../../../common/modal/update-date/update-end-date";
  import AppAddSpAdCampaign from "../../common/modal/add/campaign/add-ad-campaign";
  import AppAdLogModal from "../../../common/modal/log/ad-log-new-modal.vue";
  import {defaultVal, isMeaningful, isMeaningless, disabledEndDate} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {adStore} from "../../../common/store";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AppAdTimeAdjustStrategyOpModal from "../../../strategy/time-adjust/modal/strategy-op/time-adjust-strategy-op-modal";
  import {AdStrategyEnum} from "../../../strategy/common/enum";
  import AppStrategyAdjustLogModal from "./modal/strategy-adjust-log-modal";
  import AppAdRouteLink from "@/views/modules/ad/common/components/app-ad-route-link.vue";
  import AdDailyBudgetEdit from "@/views/modules/ad/common/components/ad-edit-dailyBudget.vue";
  import AdBidStrategyEdit from "@/views/modules/ad/common/components/ad-edit-bidStrategy.vue";
  import AdEditDateEnd from "@/views/modules/ad/common/components/ad-edit-dateEnd.vue";
  // 预算分析弹框
  import AppOutOfBudgetModal from "@/views/modules/ad/common/modal/out-of-budget/out-of-budget-modal";
  //自动规则弹窗
  import autoRule from '@/views/modules/ad/ad-automate/application/auto-rule.vue';

  import columns from './columns.js';

  import {
    adDefaultSortMixin,
    adAdvancedFilteringMixin,
    currencySymbolMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    resizeMixin,
    tableNameMixin
  } from "modules/ad/common/mixin";
  import {getResumeConditionInfo, deleteStrategy} from '../../const'

  export default {
    name: "app-sp-ad-campaign",
    components: { AppSpAdRouteLink, AppAdRouteLink, AdDailyBudgetEdit, AdBidStrategyEdit, AdEditDateEnd, autoRule },
    mixins: [tableNameMixin, inMarketMixin, isMeaningfulMixin,resizeMixin,
      inPortfolioMixin, selectionMixin, responseMixin,
      queryMixin, currencySymbolMixin, adDefaultSortMixin, adAdvancedFilteringMixin, initDateMixin],
    inject: [ 'getCornerMark' , 'removeTab', 'getNavTabs'],
    data() {
      return {
        autoRuleData: [],
        autoRuleindex: null,
        timeStamp:null,
        AdTypeEnum,
        AdCampaignEnum,
        AdStrategyStatusEnum,
        loading: false,
        notStorage: true,
        lastUpdatedDate: '',
        countryName: '',
        helpName:'spadmanager',
        disabledEndDate: disabledEndDate(new Date()),
        sumRecord: {},
        tableData: [],
        columns,
        options: {
          budgetStatus: BudgetStatus().SP.options,
        },
        filter: {
          timeStamp:null,
          servingStatus: null,
          type: null,
          strategy: null,
          strategyStatus: null,
          keyword: null,
          extendSearch: null,
          status: AdCampaignEnum.SP.statusNew.ENABLE_PAUSE,
          date: [subDays(new Date(), 6), new Date()],
          automateRuleStatus: null,
        },
        // 手动指定需要获取请求的参数的缓存key, 为了解决刷新情况下拿不到嵌套路由正确的key问题，值为当前组件name
        filterStoragekey: 'app-sp-ad-campaign',
          //自动规则状态（enabled：已添加，archived：未添加）
        automateRuleOption:[
            {id: 'enabled', text: '已添加'},
            {id: 'archived', text: '未添加'}
        ]

      }
    },
    filters: {
      bidStrategy(val) {
        let item = AdBidStrategyTypeEnumOptions.find(e => e.id == val)
        return item ? item.text : "-"
      }
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.filter.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    activated() {
       this.getTablePage();
    },
    methods: {
      isMeaningless,
      // 打开预算分析弹框
      openOutOfBudgetModal(row){
        this.$gjCreate(AppOutOfBudgetModal, {
          props: {
            row:row
          }
        });
      },
      // 列表查询
      getTablePage() {
        this.loading = true;
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignName: this.filter.keyword,
            extendSearch: this.filter.extendSearch,
            servingStatus: defaultVal(this.filter.servingStatus, null),
            states: this.filter.status ? JSON.parse(this.filter.status) : null,
            targetingType: defaultVal(this.filter.type, null),
            bidStrategy: defaultVal(this.filter.strategy, null),
            strategyStatus: defaultVal(this.filter.strategyStatus, null),
            startDate: convertToDate(this.filter.date[0]),
            endDate: convertToDate(this.filter.date[1]),
            ruleStatus: this.filter.automateRuleStatus,
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        SP.campaignsPage(params).then(data => {
          this.tableData = this.currencySymbolMixin(data.records, adStore.SP.currencySymbol);
          this.pagination = this.getPagination(data);
          this.sumRecord = data.sumRecord;
          this.lastUpdatedDate = data.lastUpdatedDate;
          this.countryName = data.countryName;
          this.loading = false; // 先结束 loading，展示数据
          //根据列表获取建议预算等数据
          let params2 = {
            marketId: this.marketId,
            campaignIds:this.tableData.map(r => r.campaignId)
          };
          if(params2.campaignIds.length>0){
            SP.budgetRecommendation(params2).then(data2 => {
              //便利数组 处理数据
              data2.forEach(m => {
                m.suggestedBudgetShow = this.dataProcess(m.suggestedBudget);//建议预算
                m.estimatedMissedSalesLower = this.dataProcess(m.estimatedMissedSalesLower);//估计错过的销售额下限
                m.estimatedMissedSalesUpper = this.dataProcess(m.estimatedMissedSalesUpper);//估计错过的销售额上限
                m.estimatedMissedImpressionsLower = this.dataProcess(m.estimatedMissedImpressionsLower);//估计错过的展示次数下限
                m.estimatedMissedImpressionsUpper = this.dataProcess(m.estimatedMissedImpressionsUpper);//估计错过的展示次数上限
                m.estimatedMissedClicksLower = this.dataProcess(m.estimatedMissedClicksLower);//估计错过的点击次数下限
                m.estimatedMissedClicksUpper = this.dataProcess(m.estimatedMissedClicksUpper);//估计错过的点击次数上限
                m.percentTimeInBudget = isMeaningless(m.percentTimeInBudget)?0:((m.percentTimeInBudget*100).toFixed(0)-0)
                //通过campaignId 匹配出相同的，把建议预算数据拼到table数据中
                let index = this.tableData.findIndex(t => t.campaignId == m.campaignId)
                if(index > -1) {
                  let item = this.tableData[index]
                  Object.assign(item, m);
                  this.$set(this.tableData, index, item)
                }
              })
            })
          }
        }).complete(() => {
          this.loading = false
        })
      },
      // 数据处理
      dataProcess(num){
        if(isMeaningless(num)){
          return null
        }
        num = parseFloat(num);
        // 小于1000，直接展示
        if(num<1000){
          return num
        }
        // 大于1000，小于1M，用K，如1789，显示为1.8k
        else if(num<1000000){
          num = num/1000;
          return num.toFixed(1)+'K'
        }
        // 大于1M，用M，如11,100,000，显示为11.1M
        else {
          num = num/1000000
          return num.toFixed(1)+'M'
        }
      },
      // 更新时间
      async updateDateEnd(val, row) {
        if (!val) {
          const params = {
            marketId: this.marketId,
            params: [ row.campaignId ]
          };
          try {
            const { data, msg, isError } = await SP.setEndDateNull(params);
            this.$gjMessage[isError ? 'error' : 'success'](msg);
            this.clearCheckboxRow();
            data && data.forEach(item => {
              let element = this.tableData.find(e => e.campaignId === item.campaignId);
                Object.assign(element, item);
            });
          } catch (error) {}
        }else {
          const params = [{
            campaignId: row.campaignId,
            endDate: convertToDate(val)
          }]
          await this.campaignsEdit(params);
        }
      },
      //按建议预算更新所有每日预算
      updateDailyBudgetAll(){
        let params = [];
        this.tableData.forEach(r => {
          if(isMeaningful(r.suggestedBudget)){
            params.push({
              campaignId: r.campaignId,
              adjustmentType: 0,
              adjustmentValue: r.suggestedBudget
            })
          }
        })
        if(params.length === 0){
          this.$message.info('应用失败，当前页广告活动无建议预算')
          return
        }
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "全部应用确认",
            content: `已选择${params.length}个广告活动，确认全部应用建议预算？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              await this.campaignsEdit(params);
              modal.$gjDestroy()
            }
          }
        });

      },
      // 更新每日预算
      async updateDailyBudget(val, row) {
        const params = [{
          campaignId: row.campaignId,
          adjustmentType: 0,
          adjustmentValue: val
        }]
        await this.campaignsEdit(params);
      },
      // 更新竞价策略
      async updateBidStrategy(form, row) {
        const { homePercentage,productPercentage, bidStrategyType } = form;
        const params = [{
          campaignId: row.campaignId,
          bidding: { 
            strategy: bidStrategyType,
            placementBidding: [
              { percentage: homePercentage, placement: 'PLACEMENT_TOP' },
              { percentage: productPercentage, placement: 'PLACEMENT_PRODUCT_PAGE' }
            ]
          }
        }]
        await this.campaignsEdit(params);
      },
      // 广告活动修改
      async campaignsEdit(param) {
        const params = {
          marketId: this.marketId,
          params: param
        }
        try {
          const { data, msg, isError} = await SP.campaignsEdit(params);
          this.$gjMessage[isError ? 'error' : 'success'](msg);
          this.clearCheckboxRow();
          data && data.forEach(item => {
            let element = this.tableData.find(e => e.campaignId === item.campaignId);
            Object.assign(element, item);
          });
        } catch (error) {}
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          filter: {
            timeStamp: this.$route.query.timeStamp,
            servingStatus: null,
            type: null,
            keyword: this.$route.query.keyword||null,
            strategy: null,
            strategyStatus: null,
            automateRuleStatus: null,
            extendSearch: null,
            status: AdCampaignEnum.SP.statusNew.ENABLE_PAUSE,
            date: this.initDate || [subDays(new Date(), 6), new Date()]
          }
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) return false;
        this.getCornerMark();
        this.getTablePage();
      },
      add() {
        this.$gjCreate(AppAddSpAdCampaign, {
          props: {
            marketId: this.marketId,
            portfolioId: this.portfolioId
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      campaignNameValidator(name) {
        return isMeaningful(name);
      },
      async updateCampaignName(name, row, closeEditor, closeLoading) {
        const params = [{
          campaignId: row.campaignId,
          campaignName: name,
        }]
        try {
          await this.campaignsEdit(params);
          closeEditor();
        } catch (error) {} finally {
          closeLoading()
        }
      },
      adjustBudget() {
        const modal = this.$gjCreate(AppAdjustBudgetModal, {
          props: {
            currencySymbol: adStore.SP.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                campaignId: e.campaignId,
                adjustmentType: modal.form.budget.key,
                adjustmentValue: modal.form.budget.value,
              }))
              try {
                await this.campaignsEdit(params);
                modal.$gjDestroy()
              } catch (error) {} finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      // 移动分组
      movePortfolio() {
        const modal = this.$gjCreate(AppMovePortfolioModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              try {
                modal.confirmLoading = true;
                if (!modal.form.portfolioId) {
                  const params = {
                    marketId: this.marketId,
                    params: this.selectedRows.map(e => e.campaignId)
                  }
                  const { data, msg, isError } = await SP.setPortfoliosNull(params);
                  this.$gjMessage[isError ? 'error' : 'success'](msg);
                  data && data.forEach(item => {
                    let element = this.tableData.find(e => e.campaignId === item.campaignId);
                    Object.assign(element, item);
                  });
                  this.clearCheckboxRow();
                  modal.$gjDestroy();
                }else {
                  const params = this.selectedRows.map(e => ({
                    campaignId: e.campaignId,
                    portfolioId: modal.form.portfolioId
                  }))
                  await this.campaignsEdit(params);
                  modal.$gjDestroy();
                }
              } catch (error) {
                console.log(error);
              } finally {
                modal.confirmLoading = false;
              }
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认启用？`: `确认启用广告活动[${rows[0].campaignName}]?`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                campaignId: e.campaignId,
                state: AdCampaignEnum.SP.status.ENABLE
              }))
              try {
                await this.campaignsEdit(params);
                modal.$gjDestroy();
              } catch (error) {
                console.error(error)
              } finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认停用？`: `确认停用广告活动[${rows[0].campaignName}]?`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = rows.map(e => ({
                campaignId: e.campaignId,
                state: AdCampaignEnum.SP.status.PAUSE
              }))
              try {
                await this.campaignsEdit(params);
                modal.$gjDestroy();
              } catch (error) {} finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              const params = this.selectedRows.map(e => ({
                campaignId: e.campaignId,
                state: AdCampaignEnum.SP.status.ARCHIVE
              }))
              try {
                await this.campaignsEdit(params);
                modal.$gjDestroy();
              } catch (error) {} finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      // 批量修改时间
      updateEndDate() {
        const modal = this.$gjCreate(AppUpdateEndDateModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: async () => {
              modal.confirmLoading = true;
              try {
                if (!modal.form.date) {
                  const params = {
                    marketId: this.marketId,
                    params: this.selectedRows.map(e => e.campaignId)
                  };
                  const { data, msg, isError } = await SP.setEndDateNull(params);
                  this.$gjMessage[isError ? 'error' : 'success'](msg);
                  data && data.forEach(item => {
                    let element = this.tableData.find(e => e.campaignId === item.campaignId);
                    Object.assign(element, item);
                  });
                  this.clearCheckboxRow();
                  modal.$gjDestroy();
                }else {
                  modal.confirmLoading = true;
                  const params = this.selectedRows.map(e => ({
                    campaignId: e.campaignId,
                    endDate: convertToDate(modal.form.date)
                  }))
                  await this.campaignsEdit(params);
                  modal.$gjDestroy();
                }
              } catch (error) {} finally {
                modal.confirmLoading = false
              }
            }
          }
        });
      },
      viewLog(row) {
        let objectName = row?.campaignName;
        this.$gjCreate(AppAdLogModal, {
          props: {
            objectName,
            marketId: this.marketId,
            adType: 'SP',
            objectType: AdLog().objCell.campaign,
            name: isMeaningful(row) ? row.campaignName : '',
          }
        });
      },
      // 广告策略
      timeAdjust(row) {
        const modal = this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            title: `<span>分时策略</span><span class="modal-secondary-title">(${row.campaignName})</span>`,
            opType: OpEnum.type.USE,
            item: row,
            objectId: row.objectId,
            strategyType: 3,// 1：广告组、关键词、商品投放、投放组， 2：广告位， 3：广告活动
          },
          on: {
            updated: () => {
              this.$gjMessage.success('操作成功');
              this.$gjResetPage();
              modal.$gjDestroy();
            },
            useStrategy: ({params, status, templateId, callback, resumeDTO}) => {
              modal.confirmLoading = true;
              let useParams;
              Promise.resolve(row.strategyStatus)
                .then((strategyStatus) => {
                  // 新增分时策略
                  if (strategyStatus === AdStrategyStatusEnum.NO_ADD) {
                    useParams = {
                      resumeDTO,
                      id: row.objectId,
                      adsStrategyTemplate: params,
                      marketId: row.marketId,
                      bid: row.dailyBudget,
                      status,
                      templateId,
                      campaignId: row.campaignId,
                      campaignName: row.campaignName,
                      objectId: row.campaignId,
                      objectName: row.campaignName,
                      objectType: AdStrategyEnum.objectType.CAMPAIGN
                    };
                    return addAdsAdjustStrategy(useParams)
                  }
                  // 修改分时策略
                  else {
                    useParams = [{
                      ...params,
                      marketId: row.marketId,
                      objectPid: row.objectId,
                      objectStatus: status,
                      templatePId:templateId,
                    }]
                    return batchUpdateStrategyObject(useParams)
                  }
                })
                .then((res) => {
                  if (callback) {
                    callback(res);
                  }
                })
                .complete(() => modal.confirmLoading = false);
            },
            viewLog: (item) => {
              this.viewAdjustLog(item);
            }
          }
        })
      },
      viewAdjustLog(row) {
        this.$gjCreate(AppStrategyAdjustLogModal, {
          props: {
            item: row,
          }
        })
      },
      // 移除，二次确认
      deleteEvent(row) {
        deleteStrategy(this, row);
        // const modal = this.$gjCreate('gj-info-modal', {
        //   props: {
        //     title: '移除确认',
        //     content: `确定要移除分时策略吗？请谨慎操作！`
        //   },
        //   on: {
        //     cancel: () => modal.$gjDestroy(),
        //     confirm: () => {
        //       modal.confirmLoading = true;
        //       getResumeConditionInfo(row.objectId, row, (res) => {
        //         modal.confirmLoading = false
        //         if (res === 'success') {
        //           this.$gjMessage.success('移除成功');
        //           this.$gjResetPage();
        //           modal.$gjDestroy();
        //         }else {
        //           this.$gjMessage.success('移除失败，请稍后重试');
        //         }
               
        //       })
        //     }
        //   }
        // });

      },
      //自动规则
      automaticRule(row) {
        const modal = this.$gjCreate(AutomaticRuleModal, {
          props: {
            subTitle: `广告活动-${row.campaignName}`,
            isAdd: true
          },
          on: {
            created: () => {
              this.$gjMessage.success('应用成功');
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        });
      },
      //添加自动规则
      handleAdd(row) {
        const extra = [{
            marketId: row.marketId,
            adsType: 'sp',
            campaignId: row.campaignId,
            applyObjectId: row.campaignId,
            applyObjectName: row.campaignName,
            applyObjectAdsType: 'campaign',
        }]
        this.handleRouter(() => {
          this.$router.push({path: `/ad/add-rule-template`, query: {
              type: 'add',
              belong: 'rule',
              sourceRoute: this.$route.path,
              extra: JSON.stringify(extra)
          }})
        }, '新增自动模板规则');
      },
      handleRouter(callback, name) {
        const tabs = this.getNavTabs();
          if (tabs.some(item => item.name === name)) {
              this.removeTab(name);
              callback();
          } else {
              callback();
          }
      },
    handleRule(row) {
      console.log(row);
    },
    // 查询自动规则详情
    handlePop(index) {
      // todo 这个地方存在一个异常的BUG，但是目前没找到原因只能暂时这样解决
      this.autoRuleindex = index;
      this.$nextTick(() => {
        this.$refs[`autoRuleRef${index}`].loading = true
        this.$refs[`autoRuleRef${index}`].query().then(res => {
          this.autoRuleData = res;
        }).finally(() => {
          this.$refs[`autoRuleRef${index}`].loading = false
        });
      })
      
    },
      // 规则pop更新列表数据
      ruleUpdate(arr, index) {
         this.$gjQuery()
      }
    }
  }
</script>

<style scoped lang="scss">
.campaignName-content {
  display: flex;
  align-items: center;
}
.popover-out{
  width: 90px;
  text-align: right;
  margin-right: 10px;
}
.popover-tit{
  padding-bottom: 12px;
  .popover-tit1{
    padding-right: 20px;
    font-weight: 600;
    color: #000;
  }
}
.popover-box{
  border: 1px solid #EEEFF0;
  box-sizing: border-box;
  border-radius: 4px;
  .popover-box-header{
    background: #F6F8FB;
    height: 32px;
  }
  .popover-box-row{
    height: 40px;
    .progress{
      width: 60px;
      margin-right: 12px;
    }
  }
  .col1{
    width: 130px;
    padding-left: 16px;
  }
  .col2{
    text-align: center;
    width: 130px;
  }
  .col3{
    text-align: center;
    width: 130px;
  }
  .col4{
    text-align: center;
    width: 130px;
  }
  .col5{
    text-align: right;
    width: 90px;
    padding-right: 20px;
  }
}
 .ad-rule-pop{
    padding: 0 !important;
  }
</style>
